BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_changed', function(event) {
  var checkboxes = document.querySelectorAll('.bold_option_value_element input[type="checkbox"].cbm_2058394_794893');
  var textElements = document.querySelectorAll('.bold_option_checkboxmulti label');

  checkboxes.forEach(function(checkbox, index) {
    checkbox.addEventListener('change', function() {
      var checkedCheckboxes = document.querySelectorAll('.bold_option_value_element input[type="checkbox"].cbm_2058394_794893:checked');
      
      if (checkedCheckboxes.length > 3) {
        this.checked = false; // Prevent checking more than 3 checkboxes
      }

      checkboxes.forEach(function(checkbox, i) {
        var isDisabled = checkedCheckboxes.length >= 3 && !checkbox.checked;

        // Disable/enable checkboxes based on the condition
        checkbox.disabled = isDisabled;
        
        // Change color of corresponding text elements based on disabled state
        textElements[i].classList.toggle('disabled-text', isDisabled);

      });
    });
  });
});